export default {"src":"/_next/static/media/payment-paypal.3bb68762.svg","height":31,"width":45,"blurWidth":0,"blurHeight":0};